import React from 'react';
import { render } from 'react-dom';
import Button from '@narvar/nth-button';
import ReturnsSidebar from '../../react-components/ReturnsSidebar/ReturnsSidebar';
import SelectList from '@narvar/nth-select-list';
import TextInput from '@narvar/nth-text-input';
import s from './returnMethodSideBar.module.css';

export const renderSidebar = ({
  closeSidebar,
  language,
  DEFAULT_LANG_COPY,
  sidebarState,
  sidebarShippingMethodConfig,
  handleSubmit,
  node,
  selectInputOptions,
  change,
}) => {
  const getFormElement = (elementProps) => {
    const nameToElementMap = {
      text: (elementProps) => (
        <TextInput
          className={`fs-exclude sidebar-input ${s.input_sidebar_holder} ${
            sidebarState.sidebarData[elementProps.key] ? 'filled-input' : ''
          }`}
          id={elementProps.key}
          key={elementProps.key}
          s={{ width: `${elementProps.width}%` }}
          type="text"
          onChange={(e) => change(elementProps.key, e)}
          defaultValue={sidebarState.sidebarData[elementProps.key]}
          label={elementProps.placeholder}
          inputClassName={s.custom_input}
          labelStyle={{ color: '#a8a8a8' }}
          inputStyle={{ color: 'black' }}
        />
      ),
      select: (elementProps) => (
        <SelectList
          className={`sidebar-select ${s.select_list}`}
          key={elementProps.key}
          defaultValue={language[`returns.step_2.sidepanel_${elementProps.key}`]}
          value={sidebarState.sidebarData[elementProps.key]}
          onChange={(e) => change(elementProps.key, e)}
          s={{ width: `${elementProps.width}%`, height: '3.125rem', color: '#000' }}
        >
          <option value={language[`returns.step_2.sidepanel_${elementProps.key}`]} disabled>
            {language[`returns.step_2.sidepanel_${elementProps.key}`]}
          </option>
          {selectInputOptions(elementProps.key).map((option, index) => (
            <option
              key={`option-${index}`}
              value={option.value}
              data-test={`sidebar-select-option-${index}`}
            >
              {option.label}
            </option>
          ))}
        </SelectList>
      ),
      divider: () => <hr key={Math.random()} />,
    };

    if (!nameToElementMap[elementProps.type]) {
      throw new Error(`FormElementFactory: No such form element ${elementProps.type}`);
    }

    return nameToElementMap[elementProps.type](elementProps);
  };

  render(
    <div>
      <ReturnsSidebar
        title={
          language['returns.step_2.sidepanel_title'] ||
          DEFAULT_LANG_COPY['returns.step_2.sidepanel_title']
        }
        toggleSide="right"
        sidebarOpen={sidebarState.open}
        closeIconOnClick={closeSidebar}
        overlayOnClick={closeSidebar}
      >
        <div>
          {sidebarState.notificationMsg ? (
            <h1 className={s.replaced_address_msg} data-test="address-validation-error">
              {sidebarState.notificationMsg}
            </h1>
          ) : null}
          <h5 className={s.section_header}>
            {language['returns.step_2.sidepanel_question'] ||
              DEFAULT_LANG_COPY['returns.step_2.sidepanel_question']}
          </h5>
          {sidebarShippingMethodConfig.map((elementProps) => getFormElement(elementProps))}
          <Button
            className="narvar-btn-primary sidebar-action-btn sidebar-done-button"
            big
            s={{ marginTop: '25px', marginBottom: '25px' }}
            disabled={!sidebarState.isValid}
            onClick={handleSubmit}
          >
            <span data-test="sidebar-button-done">
              {language['returns.step_2.sidepanel_address'] ||
                DEFAULT_LANG_COPY['returns.step_2.sidepanel_address']}
            </span>
          </Button>
        </div>
      </ReturnsSidebar>
    </div>,
    node,
  );
};
